// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPayrollGroupRequestDto
 */
export interface IPayrollGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupRequestDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupRequestDto
     */
    code?: string;
    /**
     * 
     * @type {number}
     * @memberof IPayrollGroupRequestDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPayrollGroupRequestDto
     */
    organization_path?: string;
}

/**
 * Check if a given object implements the IPayrollGroupRequestDto interface.
 */
export function instanceOfIPayrollGroupRequestDto(value: object): value is IPayrollGroupRequestDto {
    return true;
}

export function IPayrollGroupRequestDtoFromJSON(json: any): IPayrollGroupRequestDto {
    return IPayrollGroupRequestDtoFromJSONTyped(json, false);
}

export function IPayrollGroupRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPayrollGroupRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_path': json['organization_path'] == null ? undefined : json['organization_path'],
    };
}

export function IPayrollGroupRequestDtoToJSON(json: any): IPayrollGroupRequestDto {
    return IPayrollGroupRequestDtoToJSONTyped(json, false);
}

export function IPayrollGroupRequestDtoToJSONTyped(value?: IPayrollGroupRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'code': value['code'],
        'organization_id': value['organization_id'],
        'organization_path': value['organization_path'],
    };
}

